<app-message></app-message>
<div class="login">
	<div class="login-box">
		<form (ngSubmit)="reset()" id="monitor-forgotPassWord"
			[formGroup]="forgotPasswordForm">
			<br>
			<h5 class="text-blue">Forgot
				Password</h5>
			<p class="text-white-50">Enter
				your email address below and
				we'll email you a link to reset
				your password</p>
			<div
				id="forgotpassword-form text-white"
				class="form-group">

				<input ng-model="email"
					formControlName="email"
					type="email"
					class="form-control"
					id="monitor_username"
					name="monitor_username"
					placeholder="Email Address"
					autofocus>
			</div>
			<button
				class="btn btn-lg btn-primary btn-block"
				name="submit"
				type="submit">Reset
				Password</button>
		</form>
		<span class="float-right">
			<a class="btn btn-primary btn-md"
				style="margin-top:10px"
				href="/login">Back</a>
		</span>
	</div>
</div>
